import {fetchRemote} from "./api-util";
import growler from '../Util/growler';

const endpoint = '/api/HtmlEditor/';
const cache = {};

function fetchResultValue(endpoint, opts) { 
    return new Promise((resolve, reject) => {
        fetchRemote(endpoint, opts).then((response) => {
            response.json().then((data) => {
                
                if(!data.Success) {
                    const errors = data.errors || data.Errors;
                    growler.bootstrapDanger(errors.join('<br />'));
                    reject();
                }

                const value = data.value || data.Value; 
                resolve(value);

            }, reject);
        }, reject);
    });
}

export default {
    getDnxVariables() {
        const cacheKey = 'GET_DNXVAR';
        return (cache[cacheKey] = cache[cacheKey] || fetchResultValue(endpoint + 'GetDnxVariables/'));
    }
};
